import React, { useState } from 'react'
import Question from '../questionComponentsV2/question'
import _ from 'lodash'

export default function Questions(props) {
  const {
    original_id,
    questions,
    answerInfo,
    updateAnswer,
    setConfirmBtnDisabled
  } = props

  const answers = (answerInfo && answerInfo.answers) || []

  const [showFollowUps, setshowFollowUps] = useState({})

  const handleYesOrNoChange = (questionId, value) => {
    setshowFollowUps((prev) => ({
      ...prev,
      [questionId]: value
    }))
  }

  return (
    <>
      {questions.map((question, index) => {
        let skip = false
        if (question.if || question.any) {
          skip = checkSkip(question)
        }

        const questionId = question.original_id || question.id || index

        return (
          !skip && (
            <React.Fragment key={questionId}>
              <Question
                question={question}
                key={question.original_id || question.id || index}
                answers={answers}
                setConfirmBtnDisabled={setConfirmBtnDisabled}
                updateAnswer={(answer, question) =>
                  updateAnswer(answer, original_id, question)
                }
                sessionId={answerInfo && answerInfo.id}
                onYesOrNoChange={(value) =>
                  handleYesOrNoChange(questionId, value)
                }
              />

              {(showFollowUps[questionId] ||
                answers.some(
                  (ans) =>
                    ans.question_original_id === questionId &&
                    ans.answer.value === true
                )) &&
                question.follow_up &&
                Array.isArray(question.follow_up.yes) &&
                question.follow_up.yes.map((followUp) => (
                  <Question
                    question={followUp}
                    key={followUp.original_id}
                    answers={answers}
                    updateAnswer={(answer, question) =>
                      updateAnswer(answer, followUp.original_id, question)
                    }
                    sessionId={answerInfo && answerInfo.id}
                    isMenopauseFollowup={true}
                  />
                ))}
            </React.Fragment>
          )
        )
      })}
    </>
  )

  function checkSkip(question) {
    if (question.if) {
      for (const item of question.if) {
        let answer = answers.find(
          (an) => an.question_original_id === item.original_id
        )
        if (_.get(answer || {}, 'answer.value') !== item.answer) {
          return true
        }
      }
    } else if (question.any) {
      return !question.any.find((item) => {
        let answer = answers.find(
          (an) => an.question_original_id === item.original_id
        )
        if (_.get(answer || {}, 'answer.value') === item.answer) {
          return true
        }
        return false
      })
    }
  }
}
